<section class="flex min-h-0 min-w-0 flex-1 flex-col">
  @if (showTopPanel()) {
    <div>
      <ng-content select="[editorTopPanel]"></ng-content>
    </div>
  }

  <div class="grid h-full grid-rows-[1fr_auto] lg:grid-cols-[1fr_auto] lg:grid-rows-1">
    <div class="relative flex min-h-60 min-w-0 flex-1 flex-col lg:max-g-full">
      <ng-content select="[editorEmptyState]"></ng-content>

      <div class="pointer-events-none absolute inset-0 min-h-0 *:pointer-events-auto">
        <ng-content select="[editorCanvas]"></ng-content>
      </div>
    </div>

    <ng-content select="[editorAside]"></ng-content>
  </div>
</section>
